//This file contains the password strenght logic

//returns the styled html templated based on the input
let getErrorStyles = function (np) {
  var isLengthValid = this.verifyPasswordLength(np);
  var containsAlphabet = this.verifyPasswordStrengthLetter(np);
  var containsNumber = this.verifyPasswordStrengthNumber(np);
  var containsSpecialCharacter = this.verifyPasswordStrengthSpecialCharacter(np);

  var lengthMsg = APP.LANGUAGE.ResetPassword.LengthMsg;
  var alphaMsg = APP.LANGUAGE.ResetPassword.AlphaMsg;
  var numberMsg = APP.LANGUAGE.ResetPassword.NumberMsg;
  var specialCharMsg = APP.LANGUAGE.ResetPassword.SpecialCharMsg;
  var spaceBwMsg = 'mrbxxs';
  var errorMsg =
    '<div class="ui pointing  basic label error-label absolute reset-password-label-modal black no-bold"><span class="basic label black">' +
    APP.LANGUAGE.ResetPassword.PasswordMsg1 +
    '<br>' +
    APP.LANGUAGE.ResetPassword.PasswordMsg2 +
    '</span> <div class="mrts">';
  if (isLengthValid) {
    errorMsg +=
      '<div class=' +
      spaceBwMsg +
      '><i class="checkmark icon valid-reset-password-modal" ></i> <span class="valid-reset-password-modal">' +
      lengthMsg +
      ' </span></div>';
  } else {
    errorMsg +=
      '<div class=' +
      spaceBwMsg +
      '><i class="remove icon invalid-reset-password-modal" ></i>  <span class="invalid-reset-password-modal">' +
      lengthMsg +
      ' </span></div>';
  }
  if (containsAlphabet) {
    errorMsg +=
      '<div class=' +
      spaceBwMsg +
      '><i class="checkmark icon valid-reset-password-modal" ></i>  <span class="valid-reset-password-modal">' +
      alphaMsg +
      ' </span></div>';
  } else {
    errorMsg +=
      '<div class=' +
      spaceBwMsg +
      '><i class="remove icon invalid-reset-password-modal" ></i> <span class="invalid-reset-password-modal">' +
      alphaMsg +
      ' </span></div>';
  }
  if (containsNumber) {
    errorMsg +=
      '<div class=' +
      spaceBwMsg +
      '><i class="checkmark icon valid-reset-password-modal" ></i> <span class="valid-reset-password-modal">' +
      numberMsg +
      ' </span></div>';
  } else {
    errorMsg +=
      '<div class=' +
      spaceBwMsg +
      '><i class="remove icon invalid-reset-password-modal" ></i> <span class="invalid-reset-password-modal">' +
      numberMsg +
      ' </span></div>';
  }

  if (containsSpecialCharacter) {
    errorMsg +=
      '<div class=' +
      spaceBwMsg +
      '><i class="checkmark icon valid-reset-password-modal" ></i> <span class="valid-reset-password-modal">' +
      specialCharMsg +
      ' </span></div>';
  } else {
    errorMsg +=
      '<div class=' +
      spaceBwMsg +
      '><i class="remove icon invalid-reset-password-modal" ></i> <span class="invalid-reset-password-modal">' +
      specialCharMsg +
      ' </span></div>';
  }
  errorMsg += ' </div> </div>';
  return errorMsg;
};

let verifyPasswordLength = function (pw = '') {
  //checks if length of password is atleast 10 characters
  return pw.length >= 10;
};

let verifyPasswordStrengthLetter = function (pw = '') {
  //Checks if it contains atleast one alphabet
  if (pw.match(/[a-z]/i)) {
    return true;
  }
  return false;
};
let verifyPasswordStrengthNumber = function (pw = '') {
  //checks if the password contains atleast one number
  return /\d/.test(pw);
};
let verifyPasswordStrengthSpecialCharacter = function (pw = '') {
  //checks if the password contains atleast one special character
  for (var i = 0; i < pw.length; i++) {
    if (
      (pw.charCodeAt(i) >= 32 && pw.charCodeAt(i) <= 47) ||
      (pw.charCodeAt(i) >= 58 && pw.charCodeAt(i) <= 64) ||
      (pw.charCodeAt(i) >= 91 && pw.charCodeAt(i) <= 96) ||
      (pw.charCodeAt(i) >= 123 && pw.charCodeAt(i) <= 126)
    )
      return true;
  }
  return false;
};

let removeInvalidChars = function (pw = '') {
  var validString = '';
  for (var i = 0; i < pw.length; i++) {
    if (pw.charCodeAt(i) >= 32 && pw.charCodeAt(i) <= 126) {
      validString += pw.charAt(i);
    }
  }
  return validString;
};

module.exports = {
  getErrorStyles,
  verifyPasswordLength,
  verifyPasswordStrengthLetter,
  verifyPasswordStrengthNumber,
  verifyPasswordStrengthSpecialCharacter,
  removeInvalidChars,
};
